
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class GridWorldEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * (config.parallaxScale || 1.0);

        const draw = () => {
            ctx.beginPath();
            for (let x = x1; x <= x2; x += spacing) {
                ctx.moveTo(x, y1);
                ctx.lineTo(x, y2);
            }
            for (let y = y1; y <= y2; y += spacing) {
                ctx.moveTo(x1, y);
                ctx.lineTo(x2, y);
            }
            ctx.stroke();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
